import { EquipmentFormValue } from "../types";
import { CreateEquipmentVariables } from "../api/equipment/types";

export function prepareCreateUpdateEquipmentDTO(
  formData: EquipmentFormValue,
  VOId: string,
  dynamicVOId: string
): CreateEquipmentVariables["input"] {
  const { commonInfo, attachments } = formData;

  return {
    attachments,
    year: commonInfo.year,
    make: commonInfo.make,
    model: commonInfo.model,
    vendorOpportunityId: VOId,
    mileage: commonInfo.mileage,
    stockId: commonInfo.stockId,
    quantity: commonInfo.quality,
    truckClass: commonInfo.class,
    newUsed: commonInfo.condition,
    serialNumberVin: commonInfo?.vin,
    wholesaleCost: commonInfo.saleCost,
    retailPrice: commonInfo.retailPrice,
    dynamicsVendorOpportunityId: dynamicVOId,
    totalWholesaleCost: commonInfo.wholeSaleCost,
    additionalDescription: commonInfo.description,
  };
}
